<i18n src="@/locales/components/CbsDynamicFormConfig.json"></i18n>

<template>
	<div class="form-fields-draggable">
		<vs-table
			ref="table"
			class="stack-table custom-table-draggable"
			:data="value"
			:noDataText="fixedFields.length == 0 ? $t('Notify.NoDataAvailable') : ''"
		>
			<template slot="thead">
				<vs-th v-if="isEditable"></vs-th>
				<vs-th class="no-sorter">{{ $t("Id") }}</vs-th>
				<vs-th class="no-sorter">{{ $t("FieldName") }}</vs-th>
				<vs-th class="no-sorter">{{ $t("FieldType") }}</vs-th>
				<vs-th class="no-sorter">{{ $t("Required") }}</vs-th>
				<vs-th class="no-sorter">{{ $t("Enable") }}</vs-th>
				<vs-th v-if="isEditable"></vs-th>
			</template>

			<tr
				class="cursor-default"
				v-for="(field, index) in fixedFields"
				:key="`fiex-fields-${index}`"
			>
				<vs-td v-if="isEditable"></vs-td>
				<vs-td :data-header='$t("Id")'></vs-td>
				<vs-td :data-header='$t("FieldName")'>{{ field.title }}</vs-td>
				<vs-td :data-header='$t("FieldType")' class="capitalize whitespace-no-wrap">{{ $t($options.filters.filterControlTypes(field.control, requestTypeControls)) }}</vs-td>
				<vs-td :data-header='$t("Required")'>{{ $t($options.filters.filterIsRequired(field.is_optional)) }}</vs-td>
				<vs-td :data-header='$t("Enable")'>{{ $t($options.filters.filterIsRequired(field.enable)) }}</vs-td>
				<vs-td v-if="isEditable"></vs-td>
			</tr>

			<draggable
				tag="tbody"
				v-bind="$attrs"
				v-on="$listeners"
				:list="value"
				:disabled="!isEditable"
				:handle="'.btn-drag'"
				@end="handleSortField"
			>
				<tr
					:class="{'cursor-default': !isEditable}"
					v-for="(field, index) in value"
					:key="index"
					@click="isEditable && $emit('onClickItem', field, index)"
				>
					<vs-td v-if="isEditable">
						<div class="flex items-center"><i class="btn-drag nucleo nucleo-ic_drag_handle_24px text-gray-3 text-xl cursor-move" /></div>
					</vs-td>
					<vs-td :data-header='$t("Id")' class="whitespace-no-wrap">{{ field.id }}</vs-td>
					<vs-td :data-header='$t("FieldName")'>{{ field.title }}</vs-td>
					<vs-td :data-header='$t("FieldType")' class="capitalize whitespace-no-wrap">{{ $t($options.filters.filterControlTypes(field.control, requestTypeControls)) }}</vs-td>
					<vs-td :data-header='$t("Required")'>{{ $t($options.filters.filterIsRequired(field.is_optional)) }}</vs-td>
					<vs-td :data-header='$t("Enable")'>{{ $t($options.filters.filterIsRequired(!field.enable)) }}</vs-td>
					<vs-td v-if="isEditable" class="text-right">
						<i
							class="nucleo nucleo-trash-can cursor-pointer"
							@click.stop="showDeleteConfirm(field, index)"
						/>
					</vs-td>
				</tr>
			</draggable>
		</vs-table>
	</div>
</template>

<script>
import _ from "lodash";
import draggable from "vuedraggable";
import { showConfirm } from "@/mixins/mixins.js";

export default {
	mixins: [showConfirm],
	name: "FormFieldsDraggable",
	components: { draggable },
	props: {
		value: {
			type: Array,
			default() {
				return [];
			},
			validator: prop => {
				if(!_.isEmpty(prop)) {
					return prop.every(objData =>
						_.has(objData, "id") &&
						_.has(objData, "title") &&
						_.has(objData, "control") &&
						_.has(objData, "is_optional")
					)
				}
				return true;
			}
		},
		isEditable: {
			type: Boolean,
			default: false
		},
		fixedFields: {
			type: Array,
			default() {
				return [];
			},
			validator: prop => {
				if(!_.isEmpty(prop)) {
					return prop.every(objData =>
						_.has(objData, "title") &&
						_.has(objData, "control") &&
						_.has(objData, "is_optional")
					)
				}
				return true;
			}
		}
	},
	emits: {
		onSort: {},
		onClickItem: {},
		onClickDelete: {}
	},
	computed: {
		requestTypeControls() {
			return this.$constant.DYNAMIC_FORM_FIELD_CONTROLS || [];
		}
	},
	methods: {
		showDeleteConfirm(field, index) {
			this.mixinShowConfirm({
				text: this.$t("DeleteFieldConfirmWithName", { fieldName: field.title || "" })
			}).then(isAccept => {
				if (isAccept) {
					this.$emit("onClickDelete", field, index);
				}
			});
		},
		handleSortField(sortData) {
			const { oldIndex, newIndex } = sortData || {};
			if (sortData && oldIndex !== newIndex) {
				this.$emit('onSort', this.value);
			}
		}
	},
	filters: {
		filterIsRequired(is_optional) {
			if (!is_optional) {
				return "Yes";
			}
			return "No";
		},
		filterControlTypes(controlId, requestTypeControls) {
			const selectedControl = requestTypeControls.find(control => control.id === controlId) || {}
			return selectedControl.name || "";
		}
	}
};
</script>

<style lang="scss" scoped>
.form-fields-draggable {
	::v-deep .custom-table-draggable.vs-con-table td {
		&:first-child {
			padding: 1rem !important;
		}
	}
}
</style>
